import Icon from 'veui/components/Icon'
import { IconCut } from 'dls-icons-vue'

Icon.register('cut', IconCut)
